import Auth from '@/user/services/auth/Auth';
import Notifier from '../../services/Notifier';
import AppError, { TITLE_ACCESS_DENIED, TITLE_ACCESS_UNAUTHORIZED } from '../../state/AppError';
import { HttpStatus } from '../constants/httpStatus';
function generateErrorMessage(error, statusCode) {
    if (!error) {
        return '';
    }
    if (Array.isArray(error.error) && error.error.length > 0) {
        const filteredErrorMessages = error.error.filter((e) => e);
        if (filteredErrorMessages.length > 0) {
            return filteredErrorMessages.join('; ');
        }
    }
    else if (error.error instanceof Object) {
        const errorMessages = Object.values(error.error);
        if (errorMessages.length > 0) {
            return errorMessages.join('; ');
        }
    }
    if (error.message) {
        return `${error.message}`;
    }
    if (statusCode === HttpStatus.Unauthorized) {
        return TITLE_ACCESS_UNAUTHORIZED;
    }
    if (statusCode === HttpStatus.Forbidden) {
        return TITLE_ACCESS_DENIED;
    }
    return 'Server error!';
}
function handleCommonServerStatuses(res) {
    if (!res.ok) {
        switch (res.status) {
            case HttpStatus.BadRequest:
                Notifier.warn(generateErrorMessage(res.content, res.status));
                break;
            case HttpStatus.Unauthorized:
                Auth.logoutAfterSessionExpiration();
                break;
            case HttpStatus.NotFound:
            case HttpStatus.PreconditionFailed:
                break;
            default:
                Notifier.error(generateErrorMessage(res.content, res.status));
                break;
        }
    }
}
export default function HandleErrors(isSilent = false) {
    return (query) => {
        if (!isSilent) {
            handleCommonServerStatuses(query.result);
        }
        if (!query?.result?.ok) {
            throw AppError.createErrorFromCodeAndTitle(query.result.status, generateErrorMessage(query.result.content, query.result.status));
        }
        return query;
    };
}
